import React, {useState} from 'react';

export enum SelectionStep {
  MAIN,
  RADIO,
  CONFIRM,
}

export enum ManageMethod {
  SAME,
  ANOTHER,
}

function useSestExchangeHistorySelectionStep() {
  const [selectionStep, setSelectionStep] = useState(SelectionStep.MAIN);
  const [manageMethod, setManageMethod] = React.useState<ManageMethod | null>(null);
  const [selectedRecord, setSelectedRecord] = useState<number | null>(null);

  function updateSelectionStep(selectionStep: SelectionStep) {
    setSelectionStep(selectionStep);
  }

  function goToRadioStep() {
    updateSelectionStep(SelectionStep.RADIO);
  }

  function goToConfirmStep() {
    updateSelectionStep(SelectionStep.CONFIRM);
  }

  function manageAnotherRecord(recentRecordIndex: number) {
    // 다른 이력으로 관리할 경우 최근 이력으로 주기가 관리됨
    setSelectedRecord(recentRecordIndex);
    goToConfirmStep();
    setManageMethod(ManageMethod.ANOTHER);
  }

  function manageSameRecord() {
    goToRadioStep();
    setManageMethod(ManageMethod.SAME);
  }

  function updateSelectedRecord(selectedRecordIndex: number) {
    setSelectedRecord(selectedRecordIndex);
  }

  return {
    selectionStep,
    goToConfirmStep,
    manageMethod,
    selectedRecord,
    manageAnotherRecord,
    manageSameRecord,
    updateSelectedRecord,
  };
}

export default useSestExchangeHistorySelectionStep;
